import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.prod";
import { language_interface, languages_state_interface } from "../interfaces/language.interface";
import { BehaviorSubject } from "rxjs";






@Injectable({ providedIn: 'root' })
export class LanguageService
{

   private _site_language : languages_state_interface = {
      languages: [],
      active_language: {
         name: 'ar',
         code: 'ar'
      },
      language_data: {}
   };

   private _site_language_Bav = new BehaviorSubject(this._site_language);
   private _site_active_language_Code = new BehaviorSubject(null);


   constructor(
      private http: HttpClient
   ){
   }




     async request_site_languages()
   {

      return await new Promise(
         async (resolve, reject)=>{


            let active_lang = localStorage.getItem('active_lang');


                const languages:any = await  this.http.get(`${environment.ApiEndPoint2}/lang/langs`).toPromise()

                  // save languages
                     this._site_language = {
                        ...this._site_language,
                        languages: languages
                     };
                  // save active lang
                     if ( active_lang)
                     {
                        let active_lang_obj = JSON.parse(active_lang!);
                        this.set_active_language(active_lang_obj);
                        this._site_active_language_Code.next(active_lang_obj.code)

                     }
                     else
                     {
                        this.set_active_language(languages![0]);
                        this._site_active_language_Code.next(languages![0].code)
                     }

                     const langs  =   await this.http.get(`${environment.ApiEndPoint2}/lang/index`, {
                      headers: new HttpHeaders({ 'lang' : this._site_language.active_language.code })
                   }).toPromise();

                      this._site_language = {
                         ...this._site_language,
                         language_data: langs
                      };

                      this._site_language_Bav.next(this._site_language)
                      resolve(this._site_language)
                  // get and save languages data based on active language



                    })





   }


   set_active_language(active_lang: language_interface)
   {

      this._site_language = {
         ...this._site_language,
         active_language: active_lang
      };


      this.save_active_language_to_storage();

   }



   // getters
    get_site_languages()
   {

      return this._site_language_Bav

   }
   // getters code
   get_site_languages_code()
   {

      return this._site_active_language_Code

   }


   get_site_active_lang_code() : string
   {
      let temp = localStorage.getItem('active_lang');
      let lang_code = temp ? JSON.parse(temp).code : 'ar';

      return lang_code;

   }

   get_site_lang_data()
   {
      let temp = localStorage.getItem('lang_data');
      let lang_data = temp ? JSON.parse(temp) : [];

      return lang_data;
   }






   save_active_language_to_storage()
   {
      localStorage.setItem('active_lang', JSON.stringify(this._site_language.active_language));
   }


   save_lang_data_to_storage()
   {
      localStorage.setItem('lang_data', JSON.stringify(this._site_language.language_data));
   }





   // save languages to storage
   change_language(active_language: language_interface)
   {



      this._site_language = {
         ...this._site_language,
         active_language: active_language
      };

      this.save_active_language_to_storage();


      location.reload();



   }




}
